<template>
  <div class="main-menu disp-scroll" :class="{'close-menu': isClose}">
    <h3 class="menu-title">
      <p>
        <span class="mdi mdi-expand-all-outline" style="margin-right: 4px;"></span>
        ルーム
      </p>
      <button class="make-room" @click="changeModalChatRoom(true)">+</button>
    </h3>
    <template v-if="chatRooms.length > 0">
      <template v-for="(room, i) in chatRooms">
        <Tooltip
          class="tl-tip"
          message="チャットルームを開きます。"
          :key="i + '- room'"
          v-if="room.type != 2">
          <div class="room-wrapper" @click="openChatRoom(room)">
            <p class="member">
              {{room.name}}
            </p>
          </div>
        </Tooltip>
      </template>
    </template>
    <template v-else>
      <p class="member" style="font-size: smaller; color: #666;">ルームはありません</p>
    </template>
    <h3 class="menu-title">
      <p>
        <span class="mdi mdi-lan-connect" style="margin-right: 4px;"></span>
        出社中
      </p>
    </h3>
    <template v-if="onlineMenber.length > 0">
      <div
        v-for="(u, i) in onlineMenber"
        :key="i + '- 1'">
        <Tooltip class="tl-tip" :message="getStatus(u)">
          <div class="room-wrapper">
            <p class="member" @click="openChatRoomUser(u)" @mouseover="menuHover(u)">
              <template v-if="u.isOnline">
                <span class="mdi mdi-checkbox-blank-circle online"></span>
              </template>
              <template v-else>
                <span class="mdi mdi-checkbox-blank-circle-outline offline"></span>
              </template>
              {{u.name}}
            </p>
          </div>
        </Tooltip>
      </div>
    </template>
    <template v-else>
      <p class="member" style="font-size: smaller; color: #666;">オンラインメンバーはいません</p>
    </template>
    <h3 class="menu-title">
      <p>
        <span class="mdi mdi-lan-disconnect" style="margin-right: 4px;"></span>
        退社中
      </p>
    </h3>
    <template v-if="offlineMember.length > 0">
      <div v-for="(u, i) in offlineMember" :key="i + '- 2'">
        <Tooltip class="tl-tip" :message="getStatus(u)">
          <div class="room-wrapper">
            <p class="member" @click="openChatRoomUser(u)" @mouseover="menuHover(u)">
              <template v-if="u.isOnline">
                <span class="mdi mdi-checkbox-blank-circle online"></span>
              </template>
              <template v-else>
                <span class="mdi mdi-checkbox-blank-circle-outline offline"></span>
              </template>
              {{u.name}}
            </p>
          </div>
        </Tooltip>
      </div>
    </template>
    <template v-else>
      <p class="member" style="font-size: smaller; color: #666;">オフラインメンバーはいません</p>
    </template>
    <h3 class="menu-title">
      <p>
        <span class="mdi mdi-car-hatchback" style="margin-right: 4px;"></span>
        外出
      </p>
    </h3>
    <template v-if="outsideMember.length > 0">
      <div @click="openChatRoomUser(u)" v-for="(u, i) in outsideMember" :key="i + '- 3'">
        <Tooltip class="tl-tip" :message="getStatus(u)">
          <div class="room-wrapper">
            <p class="member" @mouseover="menuHover(u)">
              <span class="mdi mdi-checkbox-blank-circle online" v-if="u.isOnline"></span>
              <span class="mdi mdi-checkbox-blank-circle-outline offline" v-else></span>
              {{u.name}}
            </p>
          </div>
        </Tooltip>
      </div>
    </template>
    <template v-else>
      <p class="member" style="font-size: smaller; color: #666;">外出メンバーはいません</p>
    </template>
  </div>
</template>

<script>
import Tooltip from '@/components/atoms/tooltips/Tooltip'
export default {
  components: {
    Tooltip
  },
  props: {
    isClose: {
      type: Boolean,
      required: true
    },
    user: {
      type: Object,
      required: true,
    },
    userList: {
      type: Array,
      required: true,
    },
    chatRooms: {
      type: Array,
      required: true,
    },
  },
  computed: {
    onlineMenber () {
      let ret = []
      for (const u of this.userList) {
        // ログイン不可ユーザーは表示しない
        if (u.isWork && !u.is_agent && u.permission < 3) ret.push(u)
      }
      return ret
    },
    offlineMember () {
      let ret = []
      for (const u of this.userList) {
        // ログイン不可ユーザーは表示しない
        if (!u.isWork && !u.is_agent && u.permission < 3) ret.push(u)
      }
      return ret
    },
    outsideMember () {
      let ret = []
      for (const u of this.userList) {
        // ログイン不可ユーザーは表示しない
        if (u.isWorkOutside && !u.is_agent && u.permission < 3) ret.push(u)
      }
      return ret
    }
  },
  methods: {
    menuHover (u) {
      if (u.room) {
        this.$emit('site', [u.officeX, u.officeY, true])
        setTimeout(() => { this.$emit('site', [u.officeX, u.officeY, false]) }, 5000)
      }
    },
    getStatus (u) {
      if (u.room) {
        return '現在オフィス内に在席しております。'
      } else {
        return '現在離席中です。'
      }
    },
    openChatRoom (room) {
      this.$emit('openChatRoom', room)
    },
    openChatRoomUser (user) {
      this.$emit('openChatRoomUser', user)
    },
    changeModalChatRoom (flg) {
      this.$emit('changeModalChatRoom', true)
    }
  }
}
</script>

<style lang="scss" scoped>
.main-menu {
  width: 200px;
  height: 100%;
  background: #fefefe;
  border-right: solid thin #eee;
  overflow: auto;
}
.close-menu {
  display: none;
}
.main-menu > .menu-title {
  width: 100%;
  padding: 16px;
  font-weight: 600;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.main-menu > .menu-title {
  width: 100%;
  padding: 16px;
  font-weight: 600;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.member {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  width: 100%; text-align: left; padding-left: 24px;
  cursor: pointer;
}
.member:hover {
  background-color:rgba(240, 200, 200, 0.8);
}
.make-room {
  background: transparent;
  border: none;
  font-size: 20px;
  font-weight: 600;
}
.tl-tip {
  width: 100%;
  .room-wrapper {
    width: 100%;
    display: flex;
  }
}
.online {
  color: greenyellow;
  margin-right: 4px;
}
.offline {
  color: #222;
  margin-right: 4px;
}
</style>


// WEBPACK FOOTER //
// src/views/DashBoard/VirtualOffice/SideMenu.vue